const useScrollTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};
export default useScrollTop;
